import { render } from "./LevelComplete.vue?vue&type=template&id=725722d4&scoped=true"
import script from "./LevelComplete.vue?vue&type=script&lang=js"
export * from "./LevelComplete.vue?vue&type=script&lang=js"

import "./LevelComplete.vue?vue&type=style&index=0&id=725722d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-725722d4"]])

export default __exports__